import {
  APPLICATION_PAGE_LOADED,
  APPLICATION_PAGE_UNLOADED,
  APPLICATION_SUBMITTED,
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    // case APPLICATION_PAGE_LOADED:
    //   return {
    //     ...state,
    //     application: action.payload[0].article
    //   };
    case APPLICATION_PAGE_UNLOADED:
      return {};
    case APPLICATION_SUBMITTED:
      console.log('submitted application response', action.payload[0]);
      if(action.payload[0] && action.payload[0].isSuccess) {
        alert('Application succesfully submitted');
      }else{
        alert((action.payload[0] && action.payload[0].errorMessage) ? action.payload[0].errorMessage : 'Unexpected Error');
      }
      return {};
    default:
      return state;
  }
};
